/**
 * @generated SignedSource<<dc5f350e15cf51cc613916addde41145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarouselVariant_viewer" | "HpSharedBestsellingDesignsCarousel_viewer" | "HpSharedExcellentValuesCarouselVariant_viewer" | "HpSharedExcellentValuesCarousel_viewer" | "HpSharedMostSavedItemsCarouselVariant_viewer" | "HpSharedMostSavedItemsCarousel_viewer">;
  readonly " $fragmentType": "HpSharedLocationsModule_viewer";
};
export type HpSharedLocationsModule_viewer$key = {
  readonly " $data"?: HpSharedLocationsModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isCollectionsCapTestVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_viewer",
  "selections": [
    {
      "condition": "isCollectionsCapTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedMostSavedItemsCarousel_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedExcellentValuesCarousel_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedBestsellingDesignsCarousel_viewer"
        }
      ]
    },
    {
      "condition": "isCollectionsCapTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedMostSavedItemsCarouselVariant_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedExcellentValuesCarouselVariant_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedBestsellingDesignsCarouselVariant_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "009654c8fd44cae8336a1e53ba1108f4";

export default node;
